import {ApplicationEntity} from "@/model/entity/application-entity"
import {FieldDescriptor, FieldTypeEnum} from "@/model/entity/field-descriptor"
import {Office} from "@/model/entity/office/office"
import moment from "moment"
import {pickupDiffStatusEnumList} from "@/model/enum/pickup-diff-status-enum"

export class PickupDiff extends ApplicationEntity {
  office?: Office

  @FieldDescriptor({
    fieldType: FieldTypeEnum.DATE,
    fieldPrettyName: "entity.carorder.pickup_date",
    displayed: false,
    isFilterable: true
  })
  pickupDate: number

  @FieldDescriptor({
    fieldType: FieldTypeEnum.DATE,
    fieldPrettyName: "entity.carorder.pickup_date",
    hasTime: false,
    sortable: true,
    columnWidth: "100",
    defaultSort: "descending"
  })
  dateFrom?: number

  dateTo?: number

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.carorder.between"})
  get between(): string {
    if (exists(this.dateFrom) && exists(this.dateTo)) {
      return `${moment(new Date(this.dateFrom!)).format("HH:mm")} - ${moment(new Date(this.dateTo!)).format(
        "HH:mm"
      )}`
    }
    return ""
  }

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "Dispref", isFilterable: true})
  dispref?: string

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.carorder.name", isFilterable: true})
  name: string

  pickupType?: number

  pickupStatus?: number

  courierInvoices: boolean

  customerNumber: string

  countryIsoCode: string

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.carorder.zip_code", isFilterable: true})
  postalCode: string

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.carorder.city", isFilterable: true})
  city: string

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.carorder.street", isFilterable: true})
  street: string

  @FieldDescriptor({fieldType: FieldTypeEnum.TEXT, fieldPrettyName: "entity.carorder.house_number", isFilterable: true})
  houseNumber: string

  contactName: string

  mobile: string

  phone: string

  email: string

  fax: string

  remark: string

  numberOfParcels?: number

  weight?: number

  parcelDescription: string

  pickupTimeFrom: number

  pickupTimeTo: number

  insertDate: number

  insertUser: string

  note: string

  regularPickupsId?: number

  status?: number

  @FieldDescriptor({
    fieldType: FieldTypeEnum.SELECT,
    fieldPrettyName: "entity.carorder.status.column",
    columnWidth: "160",
    selectionFieldDescription: {
      displayKey: "i18nKey",
      valueKey: "value",
      values: pickupDiffStatusEnumList,
      i18n: true
    },
    isFilterable: true,
    fixed: true
  })
  statusId?: number

  constructor(
    name: string = "",
    pickupDate: number = 0,
    pickupType?: number,
    pickupStatus?: number,
    courierInvoices: boolean = false,
    customerNumber: string = "",
    countryIsoCode: string = "",
    postalCode: string = "",
    city: string = "",
    street: string = "",
    houseNumber: string = "",
    contactName: string = "",
    mobile: string = "",
    phone: string = "",
    email: string = "",
    fax: string = "",
    remark: string = "",
    numberOfParcels: number = 1,
    weight: number = 1,
    parcelDescription: string = "",
    pickupTimeFrom: number = 0,
    pickupTimeTo: number = 0,
    insertDate: number = 0,
    insertUser: string = "",
    note: string = "",
    regularPickupsId?: number,
    status?: number,
    id?: number,
    office?: Office
  ) {
    super(id)
    this.office = office
    this.name = name
    this.pickupDate = pickupDate
    this.pickupType = pickupType
    this.pickupStatus = pickupStatus
    this.courierInvoices = courierInvoices
    this.customerNumber = customerNumber
    this.countryIsoCode = countryIsoCode
    this.postalCode = postalCode
    this.city = city
    this.street = street
    this.houseNumber = houseNumber
    this.contactName = contactName
    this.mobile = mobile
    this.phone = phone
    this.email = email
    this.fax = fax
    this.remark = remark
    this.numberOfParcels = numberOfParcels
    this.weight = weight
    this.parcelDescription = parcelDescription
    this.pickupTimeFrom = pickupTimeFrom
    this.pickupTimeTo = pickupTimeTo
    this.insertDate = insertDate
    this.insertUser = insertUser
    this.note = note
    this.regularPickupsId = regularPickupsId
    this.status = status
  }
}
